"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ComparisonHeader.css");
var Label_1 = require("../../../../atoms/Label");
var LabelProps_1 = require("../../../../atoms/Label/LabelProps");
var utils_1 = require("../../../../../utils/utils");
var ComparisonHeader = /** @class */ (function (_super) {
    __extends(ComparisonHeader, _super);
    function ComparisonHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComparisonHeader.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.comparisonHeaderContainer },
            React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label'), data: { text: this.props.data.text }, options: { size: LabelProps_1.LabelSizes.SMALLBODY } })));
    };
    return ComparisonHeader;
}(React.Component));
exports.default = ComparisonHeader;
//# sourceMappingURL=ComparisonHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonHeader/ComparisonHeader.js
// module id = 1321
// module chunks = 8